import { render } from "./NavBar.vue?vue&type=template&id=588c7ae6&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=588c7ae6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-588c7ae6"

export default script